import ChartConstants from 'components/Chart/Constants';
import Loading from 'components/Loading';
import PathwaysBarChart from 'components/Pathway/BarChart';
import KyError from 'components/errors/KyError';
import useAppContext from 'conf/AppContext';
import {useGet} from 'helpers/KyHooks';

export default function PathwaysSection() {
  const appContext = useAppContext();
  const {response, error} = useGet('site/pathwayCategories', {
    cacheResponse: !appContext.isPreview,
  });

  let barChart = (
    <div className="gaFigure gaFigure--loading figure">
      <Loading />
    </div>
  );

  if (error) {
    barChart = <KyError kyError={error} />;
  } else if (response) {
    const data = response?.data;
    const chart = [];
    for (let x = 0; x < data.length; x += 1) {
      const {ontologyTerm, count} = data[x];
      chart.push({label: ontologyTerm.term, value: count});
    }


    barChart = (
      <PathwaysBarChart
        categories={chart}
        yAxisLabel={{truncate: ChartConstants.truncateOptions.END}}
      />
    );
  }

  return (
    <div id="section-pa">
      <h3>Pathways</h3>
      {barChart}
    </div>
  );

}
